const selectItems = [
  { type: 'MIX', value: '' },
  { type: 'EFFECT', value: '' },
];

export default selectItems;
